// extracted by mini-css-extract-plugin
module.exports = {"stepsContainer":"Steps_stepsContainer__3MLqp","stepsRow":"Steps_stepsRow__2_luK","step":"Steps_step__3hW_5","text":"Steps_text__mp9Xe"};